import { render, staticRenderFns } from "./Arcanite.vue?vue&type=template&id=c4bb5bca&scoped=true"
import script from "./Arcanite.vue?vue&type=script&lang=js"
export * from "./Arcanite.vue?vue&type=script&lang=js"
import style0 from "./Arcanite.vue?vue&type=style&index=0&id=c4bb5bca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bb5bca",
  null
  
)

export default component.exports